import React from 'react';
import { Redirect } from 'react-router-dom';

const RedirectToDefault = () => {
  return <Redirect to='/' />;
};

export default RedirectToDefault;
